import { mimeTypes } from '@/modules/base/util/constants'
import { useAppSelector, dispatch } from '@/redux/store'
import { fetchAllowedMimetypes } from '@/redux/ducks/document/upload'
import { useEffect } from 'react'
import { splitFilename } from '@/modules/_helpers/splitFilename'
import { isDmsUploadEnabled } from '@/redux/ducks/document/uploadHelpers'
import { ALLOWED_FILE_EXTENSIONS } from '@/modules/file/uploader'

const extensionToMimeTypeMap = new Map([
  ['pdf', mimeTypes.MIMETYPE_PDF],
  ['jpg', mimeTypes.MIMETYPE_JPG],
  ['jpeg', mimeTypes.MIMETYPE_JPEG],
  ['png', mimeTypes.MIMETYPE_PNG],
  ['bmp', mimeTypes.MIMETYPE_BMP],
  ['zip', mimeTypes.MIMETYPE_ZIP],
  ['xml', mimeTypes.MIMETYPE_XML],
  ['csv', mimeTypes.MIMETYPE_CSV],
  ['doc', mimeTypes.MIMETYPE_DOC],
  ['docx', mimeTypes.MIMETYPE_DOCX],
  ['xls', mimeTypes.MIMETYPE_XLS],
  ['xlsx', mimeTypes.MIMETYPE_XLSX],
  ['ppt', mimeTypes.MIMETYPE_PPT],
  ['pptx', mimeTypes.MIMETYPE_PPTX],
])

export const getMimeTypeByExtension = (filename) => {
  if (!filename) return null

  const useDmsUpload = isDmsUploadEnabled()
  let fileMimeType = extensionToMimeTypeMap.get(splitFilename(filename).suffix.replace('.', ''))

  if (useDmsUpload) {
    const allowedMimeTypes = useAppSelector((state) => state.document.upload.allowedMimetypes.map(mt => ({
      mimeType: mt.mime_type,
      extensions: (mt.extensions ?? []).map(ext => `.${ext}`),
    }))) ?? ALLOWED_FILE_EXTENSIONS
    fileMimeType = allowedMimeTypes.find(mt => mt.extensions.includes(splitFilename(filename).suffix))?.mimeType
  }

  useEffect(() => {
    dispatch(fetchAllowedMimetypes())
  }, [])

  return fileMimeType
}
